module.exports = __webpack_public_path__ + "static/media/24-10.db30279e.mp3";